/**
 * **フェイズの移行**（Issue #589）。`battle` ＝ バトルフェイズ / `other` ＝ それ以外
 * （どのフェイズかは payload の `phase` / `phaseLabel`）。フェイズの名前が無ければ null
 */
export const VARIANTS = Object.freeze([
  { name: 'battle', label: 'バトルフェイズ' },
  { name: 'other', label: 'それ以外のフェイズ' },
]);

export const isBattlePhase = (phase) => /^battle/.test(String(phase ?? '')) || /^damage/.test(String(phase ?? ''));

export default Object.freeze({
  event: 'new_phase',
  variants: VARIANTS,
  classify({ payload }) {
    if (!payload?.phaseLabel) return null;
    return { ...payload, variant: isBattlePhase(payload.phase) ? 'battle' : 'other' };
  },
});
